import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FaqAndTopLinksService {

  constructor(private http: HttpClient) { }

  getFAQLinks(): Observable<any> {
    return this.http.get('faq/all', { withCredentials: true });
  }

  getTopLinks(): Observable<any> {
    return this.http.get('top-link/all', { withCredentials: true });
  }
  getFAQLinksForAdmin(makeName): Observable<any> {
    return this.http.get(`faq/all/makeName/${makeName}`, { withCredentials: true });
  }

  getTopLinksForAdmin(makeName): Observable<any> {
    return this.http.get(`top-link/all/makeName/${makeName}`, { withCredentials: true });
  }
}
